import React from 'react'
import PropTypes from 'prop-types'
import Grid from '@mui/material/Grid2'
import IconButton from '@mui/material/IconButton'
import TextField from '@mui/material/TextField'
import DeleteIcon from '@mui/icons-material/Delete'
import { Divider, Typography, Link } from '@mui/material'
import { ImageThumbnail } from "../../shared-components";

const classes = {
  item: {
    padding: '2%',
  },
  imageIcon: {
    color: 'lightgrey',
    height: '100%',
    width: '100%'
  }
}

export default function EditOrderItem(props) {
  return (
    <React.Fragment>
      <Divider />
      <Grid container size={{ xs: 12, md: 12, lg: 12 }} spacing={3} sx={classes.item} alignItems="center">
        <Grid size={{ xs: 5, md: 6 }}>
          <Grid container spacing={1} alignItems="center">
            <Grid size={{ xs: 3, md: 3 }}>
              <ImageThumbnail image={props.product.image} width='110px' height='110px' />
            </Grid>
            <Grid size={{ xs: 9, md: 9 }}>
              <Link target='_blank' href={`/admin/products/edit/${props.product.id}`}>
                <Typography variant="h6">{props.product.name}</Typography>
              </Link>
              <p>{props.variant.name} {`${props.variant.article ? ' - ' + props.variant.article : ''}`}</p>
              <p>{props.quantity} x {props.price} {props.storeCurrency.symbol}</p>
            </Grid>
          </Grid>
        </Grid>
        <Grid size={{ xs: 3, md: 3 }}>
          <TextField
            label="Quantity"
            type="number"
            variant="outlined"
            inputProps={{ min: 1, step: 1 }}
            value={props.quantity}
            size="small"
            onChange={e => {
              const quantity = Number(e.currentTarget.value)
              if (!Number.isInteger(quantity) || quantity < 1) return
              props.onItemUpdate({id: props.id, quantity})
            }} />
        </Grid>
        <Grid size={{ xs: 2, md: 2 }}>
          {Math.round((props.quantity * props.price) * 100) / 100} {props.storeCurrency.symbol}
        </Grid>
        <Grid size={{ xs: 2, md: 1 }}>
          <IconButton color="error" onClick={e => { if (window.confirm('Are you sure?')) { props.onItemUpdate({ id: props.id, _deleted: true }) } }}>
            <DeleteIcon />
          </IconButton>
        </Grid>
      </Grid>
    </React.Fragment>
  )
}

EditOrderItem.propTypes = {
  id: PropTypes.number.isRequired,
  quantity: PropTypes.number,
  price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  product: PropTypes.object,
  variant: PropTypes.object,
  onItemUpdate: PropTypes.func.isRequired,
  storeCurrency: PropTypes.object.isRequired
}